// extracted by mini-css-extract-plugin
export var notificationHost = "_e0-0";